export default "__VITE_ASSET__BDv$VXuP__"